import Button from 'components/form/button'
import Input from 'components/form/input'
import { privateRequest } from 'config/axios.config'
import { useUser } from 'context/AuthContext'
import { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { MdAddAPhoto } from 'react-icons/md'
import { useMutation } from 'react-query'
import { assetUrl } from 'utils/url'

export default function ProfilePage() {
  const { user, setUser } = useUser()

  const avatarInputRef = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState<File>()



  const [form, setForm] = useState<{
    name: string
    email: string
    branch?: string
    role?: string
  }>({
    email: '',
    name: '',
  })

  useEffect(() => {
    setForm({
      name: user?.name ?? '',
      email: user?.email ?? '',
      branch: user?.branch?.name ?? '',
      role: user?.role ?? '',

    })
  }, [user])
  console.log(user, 'ssssssssssss')
  const changeHandler = (e: any) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const uploadAvatarMutation = useMutation<FormData, any, FormData>(
    async (payload) => {
      try {
        return await privateRequest.post('admin/profile/uploadProfilePhoto', payload, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
      } catch (err: any) {
        const status = err?.response?.status
        if (status === 413) {
          toast.error('File is too large. Maximum allowed size is 10 MB.')
        } else {
          toast.error('Avatar upload failed. Please try again.')
        }
        setFile(undefined)
        throw err
      }
    },
    {
      onSuccess: (res: any) => {
        setUser(res?.data?.user)
        toast.success(res?.data?.message || 'Profile Image uploaded successfully!')
      },
    }
  )

  const uploadAvatar = (e: any) => {
    const file = e.target.files?.[0]
    if (!file) return
    const sizeMB = file.size / 1024 / 1024
    if (sizeMB > 10) {
      toast.error('File size does not allow more than 10 MB')
      return
    }
    setFile(file)
    const formData = new FormData()
    formData.append('attachment', file)
    uploadAvatarMutation.mutate(formData)
  }

  const updateProfile = useMutation(async (payload: any) => {
    return await privateRequest.patch('admin/profile/update', payload)
  })

  const handleSubmit = (e: any) => {
    e.preventDefault()
    const { email, name } = form;
    toast.promise(updateProfile.mutateAsync({ email, name }), {
      loading: 'Updating...',
      success: (res: any) => {
        setUser(res?.data?.user)
        return res?.data?.message ?? 'Profile updated successfully'
      },
      error: (err: any) => {
        return err?.response?.data?.message ?? 'Profile update failed'
      },
    })
  }

  const avatar = (file && URL.createObjectURL(file)) || (user?.photo && assetUrl + user?.photo)

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">

      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h2 className="text-2xl  mb-6">Personal Information</h2>

        <div className="flex items-center gap-3">
          <div className="relative inline-block">
            <div className="h-32 w-32 rounded-full bg-slate-200 overflow-hidden">
              {avatar ? (
                <img className="w-full h-full object-cover" src={avatar} alt="Profile Avatar" />
              ) : (
                <div className="flex items-center justify-center h-full w-full text-gray-400">
                  <span className="text-[10px]">No Image</span>
                </div>
              )}
            </div>
            <div
              onClick={() => avatarInputRef.current?.click()}
              className="absolute bottom-0 right-0 bg-primary p-2 rounded-full  shadow cursor-pointer  transition-colors"
            >
              <MdAddAPhoto color='white' />
            </div>
          </div>

          <div className="flex flex-col gap-1">
            <p className="text-lg text-slate-500">Change Profile Image</p>
            <p className="text-sm text-slate-500">JPG, PNG or GIF. Max size 10MB.</p>
            <Button
              onClick={() => avatarInputRef.current?.click()}
              color="success"
              variant="outlined"
              size="sm"
              className="mt-2"
              disabled={uploadAvatarMutation.isLoading}
            >
              {uploadAvatarMutation.isLoading ? "Uploading..." : "Upload New Image"}
            </Button>
            <input type="file" ref={avatarInputRef} onChange={uploadAvatar} className="hidden" />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6 md:mt-10 mt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="First Name"
              value={form.name}
              name="name"
              placeholder="First Name"
              onChange={changeHandler}
            />
            <Input
              label="Email Address"
              type="email"
              value={form.email}
              name="email"
              placeholder="Enter Email Address"
              onChange={changeHandler}
            />
            <Input
              disabled={true}
              label="Branch"
              type="text"
              value={form.branch}
              // name="branch"
              placeholder="Enter Branch"
            // onChange={changeHandler}
            />
            <Input
              disabled={true}
              label="Role"
              type="text"
              value={form.role}
              // name="role"
              placeholder="Enter Role "
            // onChange={changeHandler}
            />
          </div>

          <div className="flex justify-start">
            <Button
              type="submit"
              disabled={updateProfile.isLoading}
              className="!px-10"
            >
              {updateProfile.isLoading ? 'Updating...' : 'Update Profile'}
            </Button>
          </div>
        </form>
      </div>

    </div>
  )
}